export function searchByName(name, familyName) {
    const words = name.split(" ");
    // we break it out here so you can submit individual names in different orders
    // all have to match though
    for (let i = 0; i < words.length; i++) {
        const word = words[i];
        if (familyName.toLowerCase().indexOf(word) === -1) {
            return false;
        }
    }
    return true;
}
